import { Injectable } from '@angular/core';

import { IBrowser, IOS, UAParser } from 'ua-parser-js';

@Injectable({ providedIn: 'root' })
export class UserAgentService {
  private readonly userAgentParser: UAParser;

  private static readonly BROWSER_CHROME = 'Chrome';
  private static readonly BROWSER_MOBILE_CHROME = 'Mobile Chrome';
  private static readonly BROWSER_SAFARI = 'Safari';
  private static readonly BROWSER_MOBILE_SAFARI = 'Mobile Safari';

  private static readonly DEVICE_TYPE_MOBILE = 'mobile';
  private static readonly DEVICE_TYPE_TABLET = 'tablet';

  constructor() {
    this.userAgentParser = new UAParser();
  }

  getBrowser(): IBrowser {
    return this.userAgentParser.getBrowser();
  }

  getOS(): IOS {
    return this.userAgentParser.getOS();
  }

  getDeviceType(): string | undefined {
    return this.userAgentParser.getDevice().type;
  }

  isChrome() {
    return [
      UserAgentService.BROWSER_CHROME,
      UserAgentService.BROWSER_MOBILE_CHROME,
    ].includes(this.getBrowser().name);
  }

  isSafari() {
    return [
      UserAgentService.BROWSER_SAFARI,
      UserAgentService.BROWSER_MOBILE_SAFARI,
    ].includes(this.getBrowser().name);
  }

  isMobile() {
    return this.getDeviceType() === UserAgentService.DEVICE_TYPE_MOBILE;
  }

  isTablet() {
    return this.getDeviceType() === UserAgentService.DEVICE_TYPE_TABLET;
  }

  isHandheld() {
    return this.isMobile() || this.isTablet();
  }
}
